import { render, staticRenderFns } from "./WhatsMsg.vue?vue&type=template&id=13251999&scoped=true"
import script from "./WhatsMsg.vue?vue&type=script&lang=js"
export * from "./WhatsMsg.vue?vue&type=script&lang=js"
import style0 from "./WhatsMsg.vue?vue&type=style&index=0&id=13251999&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13251999",
  null
  
)

export default component.exports